import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=696ddcb1&scoped=true"
import script from "./Recommendations.vue?vue&type=script&lang=ts"
export * from "./Recommendations.vue?vue&type=script&lang=ts"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=696ddcb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ddcb1",
  null
  
)

export default component.exports